import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { ChamadaEtapaPerfil } from '../models/response/chamada-etapa-perfil.model';
import { FaseEnum } from '../../core/enums/fase.enum';
import { EtapaEnum } from '../../core/enums/etapa.enum';

@Injectable({
  providedIn: 'root',
})
export class ChamadaEtapaPerfilService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.fullApiUrl}/chamada-etapa-perfil`;

  fetchByEtapaFaseGestor(
    etapaId: number,
    faseId: number,
    coMunicipioIbge: string
  ): Observable<ChamadaEtapaPerfil[]> {
    return this.http.get<ChamadaEtapaPerfil[]>(
      `${this.apiUrl}/etapa/${etapaId}/fase/${faseId}/gestor/${coMunicipioIbge}`,
    );
  }

  fetchByEtapaFaseGestorUf(
    etapaId: number,
    faseId: number,
    coUfIbge: string
  ): Observable<ChamadaEtapaPerfil[]> {
    return this.http.get<ChamadaEtapaPerfil[]>(
      `${this.apiUrl}/etapa/${etapaId}/fase/${faseId}/gestor-uf/${coUfIbge}`,
    );
  }

  fetchByEtapaFaseAdesaoProfissionalVigente(): Observable<ChamadaEtapaPerfil[]> {
    return this.http.get<ChamadaEtapaPerfil[]>(
      `${this.apiUrl}/etapa/${EtapaEnum.INSCRICAO}/fase/${FaseEnum.ADESAO_PROFISSIONAL}/vigente`,
    );
  }

  fetchByEtapaFaseEscolhaVigente(): Observable<ChamadaEtapaPerfil[]> {
    return this.http.get<ChamadaEtapaPerfil[]>(
      `${this.apiUrl}/etapa/${EtapaEnum.ESCOLHA_VAGA}/fase/${FaseEnum.ADESAO_PROFISSIONAL}/vigente`,
    );
  }
  
  /** Perfis vigentes para etapa/fase (ex.: escolha de vagas + adesão profissional). */
  fetchVigentePorEtapaFase(
    etapaId: number,
    faseId: number,
  ): Observable<ChamadaEtapaPerfil[]> {
    return this.http.get<ChamadaEtapaPerfil[]>(
      `${this.apiUrl}/etapa/${etapaId}/fase/${faseId}/vigente`,
    );
  }
}
